import React from 'react';
import { StyleSheet } from 'react-native';

import ShieldIcon from '@/assets/icons/shield';
import { ShieldSkiaCanvasProps } from '@/feature/player-profile-sheets/components/ShieldSkiaCanvas';

import './playerProfileImage.css';

export const ShieldSkiaCanvas = ({
    width = 130,
    height = 130,
    primaryColor,
    secondaryColor,
}: ShieldSkiaCanvasProps) => {
    return (
        <div
            className="shieldMasked"
            style={{
                ...styles.shieldContainer,
                width,
                height,
            }}
        >
            <ShieldIcon width={width} height={height} primary={primaryColor} secondary={secondaryColor} />
        </div>
    );
};

const styles = StyleSheet.create({
    shieldContainer: {
        position: 'absolute',
        opacity: 0.08,
    },
});
